export default __webpack_public_path__ + "static/media/sdk.82fbe052.png";